enum SupportedAttachFileType {
  Pdf = 'pdf',
}

export default SupportedAttachFileType;
